import { Outlet, Navigate } from 'react-router-dom'
import { getToken } from '../../../utils/cookies/cookies'

export default function PrivateRoute() {
  return getToken() ? <Outlet /> : <Navigate to='/login' />
}
